import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';

import { DISPLAY_FONT, TREND_COLORS } from '../trendTheme';

type TrendEmptyStateProps = {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
  dense?: boolean;
};

/**
 * Shared empty state so every reader/admin surface uses the same themed
 * "no data yet" treatment instead of mixing Alert/grey text/custom boxes.
 */
export default function TrendEmptyState({ title, description, icon, action, dense = false }: TrendEmptyStateProps) {
  return (
    <Box
      sx={{
        py: dense ? 4 : 7,
        px: 3,
        textAlign: 'center',
        bgcolor: TREND_COLORS.sectionBg,
        border: `1px solid ${TREND_COLORS.divider}`,
        borderRadius: 3,
      }}
    >
      <Stack spacing={1.25} alignItems="center">
        <Box sx={{ color: TREND_COLORS.textMuted, opacity: 0.5, display: 'flex' }}>
          {icon || <InsightsOutlinedIcon sx={{ fontSize: dense ? 36 : 48 }} />}
        </Box>
        <Typography sx={{ fontFamily: DISPLAY_FONT, fontSize: dense ? '1.1rem' : '1.35rem', color: TREND_COLORS.navy }}>
          {title}
        </Typography>
        {description && (
          <Typography variant="body2" sx={{ color: TREND_COLORS.textSecondary, maxWidth: 460, lineHeight: 1.6 }}>
            {description}
          </Typography>
        )}
        {action}
      </Stack>
    </Box>
  );
}
